import client from './client';

// ============================================================
// H2：品牌配置（白标 OEM；公开只读）
// ============================================================
export interface BrandConfig {
  enabled: boolean;
  name: string;
  shortName: string;
  logoUrl: string;
  faviconUrl: string;
  primaryColor: string;
  loginFooter: string;
  watermarkText: string;
  poweredBy: string;
  source: 'env' | 'file' | 'default';
}

export async function getBrandConfig(): Promise<BrandConfig | null> {
  try {
    const { data } = await client.get('/brand/config');
    return data ?? null;
  } catch {
    return null;
  }
}
